export default __webpack_public_path__ + "static/media/teraco.ab97d8ed.jpg";